module.exports = __webpack_public_path__ + "static/media/choose.3b303cf2.gif";